document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.mega-menu-wrapper').forEach((wrapper) => {
    const navWrapper = wrapper.closest('.nav-hover-wrapper');
    if (!navWrapper) return;

    const imageWrapper = wrapper.querySelector('.mega-menu-featured-image-wrapper');
    const imageGroups = imageWrapper ? imageWrapper.querySelectorAll('[data-menu-image-group]') : [];
    const defaultImageGroup = imageWrapper
      ? imageWrapper.querySelector('[data-menu-image-group="__default__"]')
      : null;

    const submenuWrapper = wrapper.querySelector('.mega-menu-submenu-wrapper');
    const submenuGroups = submenuWrapper ? submenuWrapper.querySelectorAll('[data-menu-submenu-group]') : [];
    const submenuTriggers = navWrapper.querySelectorAll('[data-menu-submenu-target]');

    // Priority: the hovered submenu's own image group, else the parent menu's
    // default image, else nothing is shown.
    const showImageGroup = (key) => {
      if (!imageWrapper) return;

      let matchedGroup = null;
      imageGroups.forEach((group) => {
        const isMatch = group.getAttribute('data-menu-image-group') === key;
        group.classList.toggle('is-active', isMatch);
        if (isMatch) matchedGroup = group;
      });

      if (!matchedGroup && defaultImageGroup) {
        defaultImageGroup.classList.add('is-active');
      }
    };

    const showDefaultImage = () => showImageGroup('__default__');

    // Hidden (and unreserved) until a submenu item with nested links is
    // hovered; only one nested submenu is open at a time.
    const showSubmenuGroup = (key) => {
      if (!submenuWrapper) return;

      let hasMatch = false;
      submenuGroups.forEach((group) => {
        const isMatch = group.getAttribute('data-menu-submenu-group') === key;
        group.classList.toggle('is-active', isMatch);
        if (isMatch) hasMatch = true;
      });
      submenuWrapper.classList.toggle('is-visible', hasMatch);

      submenuTriggers.forEach((trigger) => {
        trigger.classList.toggle('is-active-submenu', trigger.getAttribute('data-menu-submenu-target') === key);
      });
    };

    const hideSubmenu = () => showSubmenuGroup(null);

    navWrapper.querySelectorAll('[data-menu-image-target]').forEach((trigger) => {
      const imageKey = trigger.getAttribute('data-menu-image-target');
      trigger.addEventListener('mouseenter', () => showImageGroup(imageKey));
      trigger.addEventListener('focus', () => showImageGroup(imageKey));
    });

    submenuTriggers.forEach((trigger) => {
      const submenuKey = trigger.getAttribute('data-menu-submenu-target');
      trigger.addEventListener('mouseenter', () => showSubmenuGroup(submenuKey));
      trigger.addEventListener('focus', () => showSubmenuGroup(submenuKey));
    });

    // A column title with no nested links closes any currently open submenu.
    navWrapper.querySelectorAll('.mega-menu-column-title:not([data-menu-submenu-target])').forEach((trigger) => {
      trigger.addEventListener('mouseenter', hideSubmenu);
      trigger.addEventListener('focus', hideSubmenu);
    });

    navWrapper.addEventListener('mouseleave', () => {
      showDefaultImage();
      hideSubmenu();
    });

    // Keyboard equivalent of mouseleave: reset once focus moves outside the nav item entirely.
    navWrapper.addEventListener('focusout', (event) => {
      if (navWrapper.contains(event.relatedTarget)) return;
      showDefaultImage();
      hideSubmenu();
    });

    // Idle state before any submenu item has been hovered.
    showDefaultImage();
    hideSubmenu();
  });
});
